import * as React from 'react'

import { CustomHandlers, FormikWithCustomHandlersProps } from './propTypes'

interface WithCustomHandlersProps<V> extends FormikWithCustomHandlersProps<V> {
    parseLists?: boolean
    handlePostChange?: (value: any) => void
}

const withCustomHandlers = <P extends Record<string, any>, V>(
    Component: React.ComponentType<P & CustomHandlers>
): React.ComponentType<P & FormikWithCustomHandlersProps<V>> => {
    class WrappedComponent extends React.Component<
        P & WithCustomHandlersProps<V>
    > {
        constructor(props: P & WithCustomHandlersProps<V>) {
            super(props)

            this.handleChange = (value: any) => {
                const {
                    field: { name },
                    form: { setFieldValue },
                    parseLists,
                    handlePostChange,
                } = this.props

                let parsedValue = value
                if (parseLists && Array.isArray(value) && value.length > 0) {
                    const head = value.slice(0, -1)
                    const lastItem = value.slice(-1)[0]

                    if (typeof lastItem === 'string') {
                        const tail = lastItem
                            .split(/[ ,;\n]+/)
                            .filter((v: string) => v)

                        parsedValue = [...new Set([...head, ...tail])]
                    }
                }

                setFieldValue(name, parsedValue)

                if (handlePostChange) {
                    handlePostChange(parsedValue)
                }
            }

            this.handleBlur = () => {
                const {
                    field: { name },
                    form: { setFieldTouched },
                } = this.props

                setFieldTouched(name, true)
            }

            this.handleClick = this.handleBlur
        }

        handleChange: (value: any) => void
        handleBlur: () => void
        handleClick: () => void

        render(): React.ReactElement {
            const { parseLists, handlePostChange, ...rest } = this.props

            return (
                <Component
                    handleChange={this.handleChange}
                    handleClick={this.handleClick}
                    handleBlur={this.handleBlur}
                    {...(rest as P)}
                />
            )
        }
    }

    return WrappedComponent
}

export default withCustomHandlers
